var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useMemo, useState } from "react";
import moment from "moment";
import styled from "styled-components";
import colors from "../../designSystem/colors";
import theme from "../../designSystem/theme";
import { Title } from "../../designSystem";
import { AnimatePresence, motion } from "framer";
var modes = ["date", "month"];
var CalendarNavigationButton = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  background: ", ";\n  border-radius: ", ";\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  background: ", ";\n  border-radius: ", ";\n"])), colors.background.three, theme.border.radius);
var CalendarNavigationButtonArrow = styled.i(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (props) { return (props.disabled ? colors.quaternaryText : colors.text); });
var CalendarNavigationIndicator = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  flex-grow: 1;\n  align-items: center;\n  justify-content: center;\n  height: 32px;\n  margin: 0px 8px;\n  background: ", ";\n  border-radius: ", ";\n"], ["\n  display: flex;\n  flex-grow: 1;\n  align-items: center;\n  justify-content: center;\n  height: 32px;\n  margin: 0px 8px;\n  background: ", ";\n  border-radius: ", ";\n"])), colors.background.three, theme.border.radius);
var CalendarBodyItem = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  ", "\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  ", "\n"])), function (props) {
    switch (props.mode) {
        case "date":
            return "\n          width: " + (1 / 7) * 100 + "%;\n          height: 32px;\n        ";
        case "month":
            return "\n          width: " + (1 / 3) * 100 + "%;\n          height: 56px;\n        ";
    }
});
var CalendarBodyButton = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: ", "px;\n  width: ", "px;\n  border-radius: ", ";\n  transition: all 0.2s ease-in-out;\n\n  ", "\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: ", "px;\n  width: ", "px;\n  border-radius: ", ";\n  transition: all 0.2s ease-in-out;\n\n  ", "\n"])), function (props) { return (props.mode === "date" ? 32 : 40); }, function (props) { return (props.mode === "date" ? 32 : 64); }, theme.border.radiusSmall, function (props) {
    if (props.active) {
        return "\n        background: " + colors.green + "1F;\n        border: " + theme.border.width + " " + theme.border.style + " " + colors.green + ";\n      ";
    }
    if (!props.disabled) {
        return "\n        &:hover {\n          background: " + colors.background.three + ";\n        }\n      ";
    }
    return "";
});
var CalendarPicker = function (_a) {
    var minDate = _a.minDate, maxDate = _a.maxDate, initialValue = _a.initialValue, onDateSelected = _a.onDateSelected;
    var _b = useState(modes[0]), mode = _b[0], setMode = _b[1];
    var _c = useState(moment()), navigateDate = _c[0], setNavigateDate = _c[1];
    var _d = useState(initialValue), selectedDate = _d[0], setSelectedDate = _d[1];
    /**
     * Safety hook, making sure selected date does not go before min and after max
     */
    useEffect(function () {
        setSelectedDate(function (currSelectedDate) {
            if (minDate && (currSelectedDate === null || currSelectedDate === void 0 ? void 0 : currSelectedDate.isBefore(minDate))) {
                return minDate.clone();
            }
            if (maxDate && (currSelectedDate === null || currSelectedDate === void 0 ? void 0 : currSelectedDate.isAfter(maxDate))) {
                return maxDate.clone();
            }
            return currSelectedDate;
        });
        setNavigateDate(function (currNavigateDate) {
            if (minDate && (currNavigateDate === null || currNavigateDate === void 0 ? void 0 : currNavigateDate.isBefore(minDate))) {
                return minDate.clone();
            }
            if (maxDate && (currNavigateDate === null || currNavigateDate === void 0 ? void 0 : currNavigateDate.isAfter(maxDate))) {
                return maxDate.clone();
            }
            return currNavigateDate;
        });
    }, [maxDate, minDate, navigateDate, selectedDate]);
    var _e = useMemo(function () {
        switch (mode) {
            case "date":
                return [
                    minDate ? minDate.isBefore(navigateDate, "M") : true,
                    maxDate ? maxDate.isAfter(navigateDate, "M") : true,
                ];
            case "month":
                return [
                    minDate ? minDate.isBefore(navigateDate, "y") : true,
                    maxDate ? maxDate.isAfter(navigateDate, "y") : true,
                ];
        }
    }, [maxDate, minDate, mode, navigateDate]), canNavigateBack = _e[0], canNavigateForward = _e[1];
    var onNavigateBackPressed = useCallback(function () {
        if (!canNavigateBack) {
            return;
        }
        setNavigateDate(function (currNavigateDate) {
            return currNavigateDate.clone().subtract(1, mode === "date" ? "M" : "y");
        });
    }, [canNavigateBack, mode]);
    var onNavigateForwardPressed = useCallback(function () {
        if (!canNavigateForward) {
            return;
        }
        setNavigateDate(function (currNavigateDate) {
            return currNavigateDate.clone().add(1, mode === "date" ? "M" : "y");
        });
    }, [canNavigateForward, mode]);
    var calendarBody = useMemo(function () { return (_jsx(AnimatePresence, __assign({ exitBeforeEnter: true, initial: false }, { children: _jsx(motion.div, __assign({ className: "d-flex flex-wrap", initial: {
                x: -25,
                opacity: 0,
            }, animate: {
                x: 0,
                opacity: 1,
            }, exit: {
                x: 25,
                opacity: 0,
            }, transition: {
                duration: 0.1,
                type: "keyframes",
                ease: "linear",
            } }, { children: (function () {
                switch (mode) {
                    case "date":
                        var monthFirstDay = navigateDate.clone().set("D", 1);
                        var calendarFirstDate_1 = monthFirstDay
                            .clone()
                            .subtract((monthFirstDay.day() || 7) - 1, "d");
                        return (_jsxs(_Fragment, { children: [__spreadArray([], new Array(7)).map(function (_item, index) { return (_jsx(CalendarBodyItem, __assign({ mode: mode }, { children: _jsx(Title, __assign({ fontSize: 14, lineHeight: 16, color: colors.quaternaryText }, { children: moment()
                                            .day(index + 1)
                                            .format("dd")
                                            .charAt(0) }), void 0) }), index)); }), __spreadArray([], new Array(42)).map(function (_item, index) {
                                    var date = calendarFirstDate_1.clone().add(index, "d");
                                    var inTheSameMonth = date.month() === navigateDate.month();
                                    var active = Boolean(inTheSameMonth && (selectedDate === null || selectedDate === void 0 ? void 0 : selectedDate.isSame(date, "d")));
                                    var disabled = Boolean(!inTheSameMonth ||
                                        (minDate === null || minDate === void 0 ? void 0 : minDate.isAfter(date)) ||
                                        (maxDate === null || maxDate === void 0 ? void 0 : maxDate.isBefore(date)));
                                    var fontColor = colors.primaryText;
                                    if (active) {
                                        fontColor = colors.green;
                                    }
                                    if (disabled) {
                                        fontColor = colors.tertiaryText;
                                    }
                                    if (!inTheSameMonth) {
                                        fontColor = colors.quaternaryText;
                                    }
                                    if (moment().isSame(date, "day")) {
                                        fontColor = colors.green;
                                    }
                                    return (_jsx(CalendarBodyItem, __assign({ mode: mode }, { children: _jsx(CalendarBodyButton, __assign({ mode: mode, active: active, disabled: disabled, role: disabled ? "" : "button", onClick: function () {
                                                if (disabled) {
                                                    return;
                                                }
                                                setSelectedDate(function () { return date; });
                                                onDateSelected(date);
                                            } }, { children: _jsx(Title, __assign({ fontSize: 14, lineHeight: 16, color: fontColor }, { children: date.format("D") }), void 0) }), void 0) }), index));
                                })] }, void 0));
                    case "month":
                        return (_jsx(_Fragment, { children: __spreadArray([], new Array(12)).map(function (_item, index) {
                                var month = navigateDate.clone().set("M", index);
                                var disabled = Boolean((minDate === null || minDate === void 0 ? void 0 : minDate.isAfter(month, "M")) ||
                                    (maxDate === null || maxDate === void 0 ? void 0 : maxDate.isBefore(month, "M")));
                                var active = Boolean(selectedDate === null || selectedDate === void 0 ? void 0 : selectedDate.isSame(month, "M"));
                                var fontColor = colors.primaryText;
                                if (disabled) {
                                    fontColor = colors.quaternaryText;
                                }
                                if (active) {
                                    fontColor = colors.green;
                                }
                                return (_jsx(CalendarBodyItem, __assign({ mode: mode }, { children: _jsx(CalendarBodyButton, __assign({ mode: mode, active: Boolean(selectedDate === null || selectedDate === void 0 ? void 0 : selectedDate.isSame(month, "M")), disabled: disabled, role: disabled ? "" : "button", onClick: function () {
                                            if (disabled) {
                                                return;
                                            }
                                            setNavigateDate(function () { return month; });
                                            setMode("date");
                                        } }, { children: _jsx(Title, __assign({ fontSize: 14, lineHeight: 16, letterSpacing: 1, color: fontColor }, { children: month.format("MMM") }), void 0) }), void 0) }), index));
                            }) }, void 0));
                }
            })() }), navigateDate.format("MMMM YYYY")) }), void 0)); }, [maxDate, minDate, mode, onDateSelected, navigateDate, selectedDate]);
    return (_jsxs("div", __assign({ className: "d-flex flex-column w-100", style: { perspective: 1500 } }, { children: [_jsxs("div", __assign({ className: "d-flex" }, { children: [_jsx(CalendarNavigationButton, __assign({ role: canNavigateBack ? "button" : "", onClick: onNavigateBackPressed }, { children: _jsx(CalendarNavigationButtonArrow, { className: "fas fa-chevron-left", disabled: !canNavigateBack }, void 0) }), void 0), _jsx(CalendarNavigationIndicator, __assign({ role: "button", onClick: function () {
                            return setMode(function (curr) { return (curr === "date" ? "month" : "date"); });
                        } }, { children: _jsx(AnimatePresence, __assign({ exitBeforeEnter: true }, { children: _jsx(motion.div, __assign({ className: "d-flex", initial: {
                                    x: -25,
                                    opacity: 0,
                                }, animate: {
                                    x: 0,
                                    opacity: 1,
                                }, exit: {
                                    x: 25,
                                    opacity: 0,
                                }, transition: {
                                    duration: 0.1,
                                    type: "keyframes",
                                    ease: "linear",
                                } }, { children: _jsx(Title, __assign({ fontSize: 14, lineHeight: 16, letterSpacing: 1 }, { children: mode === "date"
                                        ? navigateDate.format("MMMM YYYY")
                                        : navigateDate.year() }), void 0) }), mode === "date"
                                ? navigateDate.format("MMMM YYYY")
                                : navigateDate.year()) }), void 0) }), void 0), _jsx(CalendarNavigationButton, __assign({ role: canNavigateForward ? "button" : "", onClick: onNavigateForwardPressed }, { children: _jsx(CalendarNavigationButtonArrow, { className: "fas fa-chevron-right", disabled: !canNavigateForward }, void 0) }), void 0)] }), void 0), _jsx(AnimatePresence, __assign({ exitBeforeEnter: true }, { children: _jsx(motion.div, __assign({ className: "mt-2", initial: {
                        transform: "rotateY(90deg)",
                    }, animate: {
                        transform: "rotateY(0deg)",
                    }, exit: {
                        transform: "rotateY(-90deg)",
                    }, transition: {
                        duration: 0.1,
                        type: "keyframes",
                        ease: "linear",
                    } }, { children: calendarBody }), mode) }), void 0)] }), void 0));
};
export default CalendarPicker;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=CalendarPicker.js.map